import { EmptyState } from "../components/feedback/EmptyState";
import type { WorkspaceRoute } from "../app/route-manifest";

/**
 * The screen every management route renders until it has a real data source.
 *
 * BurgePOS has no management API, so there is nothing to display. Rather than
 * fill the page with sample figures, placeholder charts or repeated summary
 * cards, each screen states what it is for, what it will show, and what it is
 * waiting for. A shop owner who opens this must never mistake a rehearsal for
 * their shop's trading position.
 */
export function PlannedWorkspaceScreen({ route }: { route: WorkspaceRoute }) {
  return (
    <div className="max-w-3xl">
      <div className="pb-7">
        <h1 className="text-4xl font-extrabold tracking-tight">{route.title}</h1>
        <p className="mt-3 leading-7 text-text-muted">{route.purpose}</p>
      </div>

      <EmptyState description={route.awaiting} title="Nothing to show yet" />

      <section aria-labelledby="planned-contents" className="mt-6 rounded-panel bg-surface-raised p-7 shadow-panel sm:p-9">
        <h2 className="text-xs font-bold tracking-wider text-text-muted uppercase" id="planned-contents">
          What this screen will show
        </h2>
        <ul className="mt-4 space-y-3">
          {route.willShow.map((item) => (
            <li className="flex gap-3 leading-7" key={item}>
              <span aria-hidden="true" className="mt-3 size-1.5 shrink-0 rounded-full bg-border-strong" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
